import { render, staticRenderFns } from "./GlobalSnackbarItem.vue?vue&type=template&id=6f9605e6&scoped=true"
import script from "./GlobalSnackbarItem.vue?vue&type=script&lang=ts"
export * from "./GlobalSnackbarItem.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSnackbarItem.vue?vue&type=style&index=0&id=6f9605e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9605e6",
  null
  
)

export default component.exports